var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BtnSelectMenu',{attrs:{"value":_vm.value,"items":_vm.items,"color":"transparent","target-class":_vm.targetClass},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }